import gsap from 'gsap'
import Constants from './Constants'

export default class LoaderAnimations
{
    constructor()
    {
        this.text1 = document.getElementById('loader_text_1')
        this.text2 = document.getElementById('loader_text_2')
        this.overlay = document.querySelector('#loader_div')
        this.progressBar = document.querySelector('#loader_bar_fill_container')

        this.loaderTimeline = gsap.timeline()
    }

    update(val)
    {
        const maskDistance = 100 * (1 - val)
        this.progressBar.style.clipPath = `inset(0 ${maskDistance}% 0 0)`
    }

    end()
    {
        this.overlay.style.opacity = 0
        this.overlay.style.pointerEvents = 'none'
    }
}